var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list"},_vm._l((_vm.tags),function(tag){return _c('li',{key:tag.id,staticClass:"line"},[_c('button',{staticClass:"tag-button",on:{"click":() => _vm.toTagTab(tag)}},[_c('TagSvgWithColor',{attrs:{"tag":tag}}),_c('div',{class:['menuText', { menuTextActive: _vm.isMenuOpen }]},[_vm._v(" "+_vm._s(tag.name)+" ")])],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }